// Import styles
import '../sass/main.scss';

// Import vendor libs
import 'jquery';
import 'intl-tel-input/build/js/utils.js';
import 'intl-tel-input';
import './foundation.js';
import 'flatpickr/dist/flatpickr.css'
import 'flatpickr/dist/flatpickr.js'
import UAParser from 'ua-parser-js';

import './ajaxDefaults.js';

import * as Plugins from "./plugins.js";

window.MyAngelcam = Plugins;
window.UAParser = UAParser;



// WEBPACK FOOTER //
// ./src/resources/js/common.js